(function($) {
	"use strict";

	var counter = 0;

	function MaterialInputFloating(target, options) {
		// Encapsuler l'input dans un div, pour l'accompagner d'un label
		this.input = $(target).data('material', this).wrap('<span class="bbm-input-floating"></span>');
		// S'assurer qu'il a un id pour la propriété "for" du label
		if (!this.input.attr('id'))
			this.input.attr('id', options.id || ('bbm-input-floating-' + (++counter)));

		// Prise en compte des options via des classes sur le parent
		this.container = this.input.parent()
			.toggleClass('bbm-inverse', options.inverse)
			.toggleClass('bbm-dense', options.dense);

		// Créer un label pour l'input avec le placeholder comme texte
		this.label = $('<label />')
			.attr('for', this.input.attr('id'))
			.text(this.input.attr('placeholder') || options.placeholder)
			.prependTo(this.container);

		// Supprimer le placeholder pour utiliser le label à la place
		this.input.removeAttr('placeholder')
			.on('focus', this.onfocus.bind(this))
			.on('blur', this.onblur.bind(this));

		// Positionner le label correctement au départ
		this.update();
	}

	MaterialInputFloating.prototype.onfocus = function() {
		// Pendant que l'input le focus, on remonte le label au dessus
		this.label.removeClass('placeholder');
	};

	MaterialInputFloating.prototype.onblur = function() {
		// Si on quitte le champ encore vide, on repositionne le label dans l'input, comme un placeholder
		if (! this.input.val())
			this.label.addClass('placeholder');
	};

	MaterialInputFloating.prototype.update = function() {
		this.label.toggleClass('placeholder', !(this.input.val() || this.input.is(':focus')));
	};

	MaterialInputFloating.prototype.destroy = function() {
		this.input.attr('placeholder', this.label.text()).insertBefore(this.container);
		this.input.removeData('material');
		this.container.remove();
	};

	$.fn.materialInputFloating = function(action) {

		// Configuration par défaut
		var defaultOptions = {
			/** Indique si on utilise la variante sur fond foncé (inverse=true) ou clair (inverse=false ou absent) */
			inverse: false,
			/** Indique si on utilise la version dense de l'input, qui prend moins de place */
			dense: false,
		};

		return this.each(function() {
			if (typeof action === 'object') {
				// Création
				var options = $.extend({}, defaultOptions, action);
				new MaterialInputFloating(this, options);

			} else if (action === 'update') {
				// Après modification manuelle, permet de repositionner correctement le label
				$(this).data('material').update();

			} else if (action === 'destroy') {
				// Destruction
				$(this).data('material').destroy();
			}
		});
	};

	function MaterialCheckbox(target, options) {
		this.input = $(target).data('material', this).wrap('<span class="bbm-checkbox"></span>');
		this.container = this.input.parent().toggleClass('bbm-inverse', options.inverse);
		this.button = $('<button type="button"><i class="material-icons"></i></button>').appendTo(this.container).on('click', function() {
			if (!this.input.prop('disabled'))
				this.input.prop('checked', !this.input.prop('checked')).change();
		}.bind(this));
	}

	MaterialCheckbox.prototype.destroy = function() {
		this.input.insertBefore(this.container);
		this.input.removeData('material');
		this.container.remove();
	};

	$.fn.materialCheckbox = function(action) {

		// Configuration par défaut
		var defaultOptions = {
			/** Indique si on utilise la variante sur fond foncé (inverse=true) ou clair (inverse=false ou absent) */
			inverse: false,
		};

		return this.each(function() {
			if (typeof action === 'object') {
				// Création
				var options = $.extend({}, defaultOptions, action);
				new MaterialCheckbox(this, options);

			} else if (action === 'destroy') {
				// Destruction
				$(this).data('material').destroy();
			}
		});
	};

	function MaterialRadio(target, options) {
		this.input = $(target).data('material', this).wrap('<span class="bbm-radio"></span>');
		this.container = this.input.parent().toggleClass('bbm-inverse', options.inverse);
		this.button = $('<button type="button"><i class="material-icons"></i></button>').appendTo(this.container).on('click', function() {
			if (!this.input.prop('disabled'))
				this.input.prop('checked', !this.input.prop('checked')).change();
		}.bind(this));
	}

	MaterialRadio.prototype.destroy = function() {
		this.input.insertBefore(this.container);
		this.input.removeData('material');
		this.container.remove();
	};

	$.fn.materialRadio = function(action) {

		// Configuration par défaut
		var defaultOptions = {
			/** Indique si on utilise la variante sur fond foncé (inverse=true) ou clair (inverse=false ou absent) */
			inverse: false,
		};

		return this.each(function() {
			if (typeof action === 'object') {
				// Création
				var options = $.extend({}, defaultOptions, action);
				new MaterialRadio(this, options);

			} else if (action === 'destroy') {
				// Destruction
				$(this).data('material').destroy();
			}
		});
	};

	// Pour afficher une snackbar
	$.materialSnackbar = function(options) {
		// Le message étant le seul paramètre obligatoire, on supporte la notation $.materialSnackbar('message');
		if (typeof options === 'string')
			options = { message: options };

		// TODO : les snackbar peuvent être fermées par "swipe" de l'utilisateur mais pas les toast
		// TODO : le timeout s'interrompt pendant l'affichage d'une modale ou autre vue pour reprendre quand la fenêtre reprend le focus
		var snackbar = $.extend({ timestamp: Date.now() }, $.materialSnackbar.defaultOptions, options);

		// Eviter les messages en double
		var message = $('body > .bbm-snackbar .bbm-snackbar-messages');
		var last = message.children(':last-child');
		if (last.length > 0) {
			var lastSnackbar = last.data('snackbar');
			// Seules les snackbar avec même message et même action (ou pas d'action) sont zappés
			if (lastSnackbar.message === snackbar.message && lastSnackbar.callback === snackbar.callback) {
				// Par contre, annuler le timeout précédent
				if (lastSnackbar.duration > 0)
					clearTimeout(lastSnackbar.timeout);
				// Et démarrer un nouveau timeout pour masquer le message
				if (snackbar.duration > 0)
					lastSnackbar.timeout = setTimeout(function() {
						$.materialSnackbar.hide(last);
					}, snackbar.duration);
				// Appliquer un effet pour montrer que le message est pris en compte
				if (Date.now() - lastSnackbar.timestamp > 1000) {
					lastSnackbar.timestamp = Date.now(); // ne pas en déclencher 2 autres en même temps
					last.animate({'opacity': '0.5'}, 'fast', function() {
						last.animate({'opacity': '1'}, 'fast', function() {
							lastSnackbar.timestamp = Date.now(); // ne pas en déclencher d'autres avant 1s
						});
					});
				}
				return;
			}
		}

		var div = $(''
				+ '<div class="bbm-snackbar-message">'
				+ '  <button type="button" class="btn btn-link text-muted"><i class="material-icons material-icons-16">clear</i></button>'
				+ '  <div>'
				+ '    <span />'
				+ '    <b class="material-icons material-icons-16">arrow_drop_down</b>'
				+ '    <b class="material-icons material-icons-16">arrow_drop_up</b>'
				+ '    <ul />'
				+ '  </div>'
				+ '  <button type="button" class="btn btn-link text-muted"></button>'
				+ '</div>')
			.data('snackbar', snackbar)
			.toggleClass('bbm-snackbar-error', !!snackbar.error);
		// A gauche, le bouton pour fermer ce message
		div.children(':first-child').click(function() {
			$.materialSnackbar.hide(div);
		});
		// Au centre, le message
		div.find('span').text(snackbar.message);
		// En dessous, le détail éventuel
		if (options.details && options.details.length > 0)
			div.addClass('bbm-snackbar-details bbm-snackbar-expanded')
				.find('ul').append(options.details.map(function(d) { return $('<li />').text(d)[0]; }));
		// A droite, le bouton d'action éventuel
		if (!!snackbar.button && !!snackbar.callback)
			div.children(':last-child')
				.text(snackbar.button)
				.click(snackbar.callback);

		$.materialSnackbar.show(div);
		if (snackbar.duration > 0) {
			snackbar.timeout = setTimeout(function() {
				$.materialSnackbar.hide(div);
			}, snackbar.duration);
		}
	};

	$.materialSnackbar.defaultOptions = {
		/* Le message principal de la snackbar. Il est obligatoire mais il n'y a pas de valeur par défaut */
		// message: '',
		/* Un tableau de détail pour la validation des formulaires, affichant un "ul". Par défaut, il n'y a pas de détail */
		// details: [],
		/* Indique si le message est une erreur ou un simple message d'information */
		error: false,
		/* Indique le temps (en ms) avant la fermeture automatique de la snackbar. O (zéro) désactive la fermeture automatique */
		duration: 0,
		/* Le texte du bouton d'action si on souhaite activer l'unique action autorisée dans les snackbars */
		button: '',
		/* La fonction qui sera appelée quand on clique sur le bouton, à condition d'avoir demandé son affichage en précisant son texte */
		callback: $.noop,
		/* Le texte du bouton "OK" servant à fermer l'ensemble des snackbars en une fois */
		ok: 'OK',
	};

	// Le conteneur, qu'on ajoute une fois et pourra contenir plusieurs messages
	$.materialSnackbar.show = function(snackbar) {
		// Récupérer le conteneur des snackbars
		var container = $('body > .bbm-snackbar');
		// Vérifier s'il est présent car cela signifie qu'on ajoute un deuxième message
		var first = container.length === 0;
		if (first) {
			// Créer le conteneur
			container = $(''
					+ '<div class="bbm-snackbar">'
					+ '  <div class="bbm-snackbar-container">'
					+ '    <div class="bbm-snackbar-messages"></div>'
					+ '    <div class="bbm-snackbar-general">'
					+ '      <button type="button" class="bbm-snackbar-ok btn btn-link"></button>'
					+ '    </div>'
					+ '  </div>'
					+ '</div>');
			// Ajouter dans l'arbre DOM (pour l'instant non visible)
			container.appendTo(document.body);
		}
		// Ajouter le message demandé
		var messages = container.find('.bbm-snackbar-messages');
		messages.append(snackbar).css('max-height', (window.innerHeight - 38) + 'px');
		// Afficher le bouton OK si au moins 2 messages sont présents
		var ok = container.find('.bbm-snackbar-ok');
		ok.text($.materialSnackbar.defaultOptions.ok);
		if (first) {
			// Faire apparaitre la snackbar en bas lors de l'affiche du 1er message
			container.animate({'bottom': '0%'}, 'fast');
			// Tout fermer en cliquant sur "OK"
			ok.click(function() {
				// Retirer le conteneur (avec une animation) s'il n'y a plus de message
				container.animate({'bottom': '-100%'}, 'fast', function() {
					container.remove();
				});
			});
			// Afficher / cacher le détail d'un message quand on clique sur le texte principal
			container.on('click', '.bbm-snackbar-details span', function(event) {
				$(event.target).closest('.bbm-snackbar-details').toggleClass('bbm-snackbar-expanded');
			});
			// Ajuster la hauteur max
			$(window).on('resize', $.materialSnackbar.resize);
		}
	};

	$.materialSnackbar.resize = function(event) {
		$('body > .bbm-snackbar .bbm-snackbar-messages').css('max-height', (window.innerHeight - 38) + 'px');
	};

	$.materialSnackbar.hide = function(snackbar) {
		var container = $('body > .bbm-snackbar');
		var messages = container.find('.bbm-snackbar-message');
		if (messages.length === 1) {
			// Retirer le conteneur (avec une animation) si on cache le dernier message
			container.animate({'bottom': '-100%'}, 'slow', function() {
				container.remove();
				$(window).off('resize', $.materialSnackbar.resize);
			});
		} else {
			// Faire disparaitre (par une animation) le message demandé
			snackbar.animate({'opacity': 0}, 'slow', function() {
				// Ne pas laisser le bouton "OK" seul si les 2 derniers ont été retirés "en même temps"
				if (snackbar.siblings().length === 0) {
					container.remove();
				} else {
					snackbar.remove();
				}
			});
		}
	};

	function MaterialPopin(target, options) {
		var bodyOverflow = document.body.style.overflow;
		var addToDOM = target.parentNode === null;
		var self = $(target);
		var popin = $(''
			+ '<div class="bbm-popin-background">'
			+ '  <div class="bbm-popin">'
			+ '    <div class="bbm-popin-header bbm-popin-header-0">'
			+ '      <button type="button" class="bbm-popin-close"><i class="material-icons">arrow_back</i></button>'
			+ '      <span></span>'
			+ '      <div class="bbm-popin-buttons"></div>'
			+ '    </div>'
			+ '    <div class="bbm-popin-content"></div>'
			+ '  </div>'
			+ '</div>'
		);
		var header = popin.find('.bbm-popin-header');
		var buttonsDiv = popin.find('.bbm-popin-buttons');

		if (addToDOM)
			popin.appendTo(document.body);
		else
			popin.insertAfter(self);
		if (typeof options.zIndex !== 'undefined')
			popin.css('z-index', options.zIndex);
		self.appendTo(popin.find('.bbm-popin-content'));

		// Le comptage des boutons permet d'ajuster la largeur max du titre
		var buttonCount = 0;
		function updateButtonCount(count) {
			header.removeClass('bbm-popin-header-' + buttonCount);
			buttonCount = count;
			header.addClass('bbm-popin-header-' + buttonCount);
		}

		function title(title) {
			header.children('span').text(title);
		}
		
		// La méthode à appeler pour fermer le popin
		function close() {
			if (options.onclose)
				options.onclose();
			if (addToDOM) {
				// Retirer le contenu en même temps que le popin
				popin.remove();
			} else {
				// Retirer le popin mais conserver le contenu là où il était avant l'ouverture du popin
				self.insertBefore(popin);
				popin.remove();
			}
			// Restaurer le "overflow" du body tel qu'il était à l'ouverture
			document.body.style.overflow = bodyOverflow;
		}

		// Fermer le popin via .materialPopin('close')
		this.close = close;

		// Fermer le popin quand on clique sur la flèche "Retour"
		popin.on('click', '.bbm-popin-close', function(event) {
			close();
		});
 
		// Déclarer une fonction pour gérer le titre
		this.title = title;
		// Le titre du popin
		title(self.attr('data-title') || self.attr('title') || options.title);

		// liste de boutons { "icon": material icon, "onclick": function, "title": text, "visible": true/false, "focus": true/false, "primary": boolean
		options.buttons = options.buttons || [];
		// Ajout en gestion automatique d'un bouton 'Fermer' à droite
		options.buttons.push({
			icon : 'clear',
			focus: true,
			visible : true,
			title: options.closeButtonTitle,
			onclick : function() {
				close();
			}
		});

		// Les boutons à droite en haut du popin
		var focusButton = null;
		var clearButton = null;
		options.buttons.forEach(function(definition) {
			var button = $('<button type="button" class="bbm-fab"></button>')
				.text(definition.icon || 'done')
				.toggle(!!definition.visible)
				.toggleClass('bbm-fab-primary', !!definition.primary)
				.appendTo(buttonsDiv);

			// Historiquement, on avait "onclick", qui lance une action mais sans gestion du timing
			// donc pas possible de désactiver le bouton temporairement ou de fermer le popin à la fin.
			// J'ai ajouté "onclickPromise" qui vise à remplacer "onclick" en "mieux" :
			// - le bouton est désactivé avant d'appeler "onclickPromise"
			// - si la promesse est résolue, le popin est automatiquement fermé
			// - si la promesse est rejetée, le popin reste ouvert et le bouton est réactivé
			if (definition.onclick) {
				button.on('click', definition.onclick);
			} else {
				button.on('click', function() {
					button.prop('disabled', true);
					definition.onclickPromise().then(function() {
						close();
					}, function() {
						button.prop('disabled', false);
					});
				});
			}

			if (definition.title)
				button.attr('title', definition.title);
			// Le bouton est affiché si demandé. Pour le bouton 'close', on l'affiche s'il ne fait pas doublon
			if (!!definition.visible && (definition.icon !== 'clear' || clearButton == null))
				buttonCount++;
			// On repère le 1er bouton demandant le focus
			if (definition.focus && focusButton == null)
				focusButton = button;
			// On repère le 1er bouton avec l'icone 'clear' pour ne pas afficher le bouton 'close' s'il est en doublon
			if (definition.icon === 'clear' && clearButton == null)
				clearButton = button;
		});
		updateButtonCount(buttonCount);

		// Afficher / Cacher les boutons à la demande
		self.on('setbuttons', function(event, icons) {
			var buttons = header.find('.bbm-fab').hide();
			var clearFound = false;
			if (icons) {
				icons = icons.split(' ');
				buttons.filter(function() {
					var icon = this.innerHTML;
					var visible = (icons.indexOf(icon) >= 0) && (icon !== 'clear' || !clearFound);
					if (icon === 'clear')
						clearFound = true;
					return visible;
				}).show();
			} else {
				icons = [];
			}
			// Si on n'a pas demandé de bouton 'clear', on affiche le bouton 'close' géré par défaut
			if (icons.indexOf('clear') < 0) {
				icons.push('clear');
				buttons.last().show();
			}
			// Mettre à jour le style en fonction du nombre de boutons
			updateButtonCount(icons.length);
		});

		// Cacher la barre de scroll du document pendant que le popin est affiché
		document.body.style.overflow = 'hidden';
		// Afficher le popin
		popin.show();
		// Donner le focus, si demandé
		if (focusButton)
			focusButton.focus();
	}

	// Configuration par défaut
	MaterialPopin.defaultOptions = {
		// texte ou attribut "data-title" de "this" ou attribut "title"
		title: '',
		// pour ajuster z-index si la valeur par défaut 1 ne convient pas
		zIndex: undefined
	};

	$.fn.materialPopin = function(userOptions, param) {
		if (typeof userOptions === 'object') {
			// Ouverture
			var options = $.extend({}, MaterialPopin.defaultOptions, userOptions);
			return this.each(function() {
				var popin = new MaterialPopin(this, options);
				$(this).data('popin', popin);
			});

		} else if (userOptions === 'close') {
			// Fermeture
			return this.each(function() {
				var self = $(this);
				self.data('popin').close();
				self.removeData('popin');
			});

		} else if (userOptions === 'title') {
			// Mettre à jour le libellé
			return this.each(function() {
				var self = $(this);
				self.data('popin').title(param);
			});

		}  
		else if (userOptions === undefined) {
			// Getter
			return this.data('popin');

		} else {
			throw new Error('Paramètre non supporté pour le composant  "materialPopin" : ' + userOptions);
		}
	};

	function MaterialBook(target, options) {
		// Ajout du squelette du book, sans le contenu
		this.target = $(target).empty().addClass('bbm-book')
			.toggleClass('bbm-book-no-search', !options.search)
			.toggleClass('bbm-book-no-description', !options.description)
			.append(''
				+ '<div class="bbm-book-search">'
				+ '  <input type="search" class="form-control" placeholder="' + options.searchPlaceholder + '" />'
				+ '</div>'
				+ '<div class="bbm-book-content"></div>'
				+ '<div class="bbm-book-position">1 / 1</div>'
				+ '<i class="material-icons bbm-rotate bbm-wait">refresh</i>'
				+ '<button type="button" class="btn btn-link bbm-book-prev"><i class="material-icons">navigate_before</i></button>'
				+ '<button type="button" class="btn btn-link bbm-book-next"><i class="material-icons">navigate_next</i></button>'
				+ '');
		// Récupération des éléments principaux une fois pour toute
		this.cursor = this.target.children('i.bbm-wait');
		this.search = this.target.children('.bbm-book-search');
		this.content = this.target.children('.bbm-book-content').css('flex-direction', options.direction);
		this.position = this.target.children('.bbm-book-position');
		this.prev = this.target.children('.bbm-book-prev');
		this.next = this.target.children('.bbm-book-next');
		// Récupération des options dont on aura besoin ultérieurement
		this.itemCount = options.itemCount;
		this.getURL = options.getURL;
		this.describeItem = options.describeItem;
		this.searchItem = options.searchItem;
		this.onselect = options.onselect;
		this.ondbltap = options.ondbltap;
		this.onupdate = options.onupdate;
		this.onupdateload = options.onupdateload;
		// Quelques données qui évolueront pendant l'utilisation
		this.items = options.items;
		this.visibleItems = options.items;
		this.index = options.index;
		this.slideshowInterval = null;
		this.slideshowPaused = !options.slideshow;
		// Gestion des évènements
		this.internalConnectEvents(options);
		// Affichage initial
		this.update(false);
	}

	MaterialBook.prototype.destroy = function() {
		this.target.empty().removeClass('bbm-book bbm-book-no-search bbm-book-no-description');
		if (this.slideshowInterval)
			clearInterval(this.slideshowInterval);
	};

	MaterialBook.prototype.setContent = function(newItems, newIndex) {
		// Garder la liste des éléments
		this.items = newItems || [];
		// Calculer "visibleItems" en appliquant les filtres
		this.filter();
		// Transformer l'index demandé dans newItems en un index dans visibleItems (ou 0 par défaut)
		this.index = Math.max(0, this.visibleItems.indexOf(this.items[newIndex || 0]));
		// Raffraichir le visuel
		this.update(false);
		// Redémarrer le défilement si les options demandaient le défilement
		this.resumeSlideshow();
	};

	MaterialBook.prototype.setDirection = function(direction) {
		this.content.css('flex-direction', direction === 'column' ? 'column' : 'row');
	};

	MaterialBook.prototype.toggleDescription = function() {
		this.target.toggleClass('bbm-book-no-description');
	};

	MaterialBook.prototype.toggleSearch = function() {
		this.target.toggleClass('bbm-book-no-search');
	};

	MaterialBook.prototype.pauseSlideshow = function() {
		this.slideshowPaused = true;
	};

	MaterialBook.prototype.resumeSlideshow = function() {
		this.slideshowPaused = false;
	};

	MaterialBook.prototype.internalConnectEvents = function(options) {
		// Navigation par les boutons
		this.next.on('click', function() { this.showNext(true); }.bind(this));
		this.prev.on('click', function() { this.showPrevious(true); }.bind(this));

		// Navigation par "swipe"
		this.target.swipe().on('swipe', function(event, swipe) {
			// swipe.duration: milliseconds between "touchstart" and "touchend" events
			// swipe.direction: 8 directions including "top" "bottom" "left" "right"
			if ((swipe.direction === 'left') && this.next.is(':visible'))
				this.showNext(true);
			else if ((swipe.direction === 'right') && this.prev.is(':visible'))
				this.showPrevious(true);
		}.bind(this));

		// Recherche par la zone de texte
		this.search.on('change', function(event) {
			this.pauseSlideshow();
			this.index = 0;
			this.filter();
			this.update(false);
		}.bind(this));

		// Défilement automatique
		if (options.slideshow) {
			this.slideshowInterval = setInterval(function() {
				if (this.slideshowPaused)
					return;
				if (this.next.is(':visible'))
					this.showNext(false);
				else if (this.prev.is(':visible'))
					this.showFirst();
			}.bind(this), options.slideshowInterval);
		}

		// Sélection d'une miniature
		if (this.onselect && this.itemCount > 1) {
			this.target.on('click', '.bbm-book-entry', function(event) {
				var entry = $(event.target).closest('.bbm-book-entry');
				var selected = entry.hasClass('bbm-book-entry-selected');
				if (!selected) {
					// Sélection des entrées par clic, sauf si on clic sur des cases vides
					var arrayIndex = this.index + entry.index();
					if (arrayIndex < this.visibleItems.length) {
						entry.addClass('bbm-book-entry-selected').siblings().removeClass('bbm-book-entry-selected');
						this.pauseSlideshow();
						this.onselect(this.visibleItems[arrayIndex]);
					}
				} else {
					// Désélection des entrées par clic, sauf si on souhaite gérer "dbltap" 
					if (!this.ondbltap) {
						entry.removeClass('bbm-book-entry-selected');
						this.onselect(null);
					}
				}
			}.bind(this));
		}

		// Lancement du diaporama
		if (this.ondbltap) {
			this.target.on('dbltap', '.bbm-book-entry', function(event) {
				var i = this.index + $(event.target).closest('.bbm-book-entry').index();
				if (i < this.visibleItems.length) {
					this.pauseSlideshow();
					this.ondbltap(this.visibleItems, i);
				}
			}.bind(this));
		}
	};

	MaterialBook.prototype.internalHide = function(animation, callback) {
		if (this.visibleItems.length === 0) {
			// Si rien à afficher : masquer content, position, prev et next
			if (animation)
				this.search.siblings().fadeOut(callback);
			else {
				this.search.siblings().hide();
				callback();
			}
		} else {
			// Sinon, masquer les éléments précédents avant d'afficher les nouveaux
			if (animation)
				// fadeOut pour le masquer jusqu'au fadeIn une fois prêt (= animation)
				this.content.fadeOut(function() {
					this.textContent = ''; // this === content
					callback();
				});
			else {
				// show pour que son contenu apparaisse dès l'ajout (= pas d'animation)
				this.content.show().empty();
				callback();
			}
		}
	};

	MaterialBook.prototype.internalShow = function(animation, onimgload) {
		for (var i = 0; i < this.itemCount; i++) {
			var div = $('<div class="bbm-book-entry" />').appendTo(this.content);
			if (this.index + i >= this.visibleItems.length)
				continue;
			var item = this.visibleItems[this.index + i];

			// Affichage de l'image en utilisant une image pour le chargement afin d'être prévenu par "load" quand elle est prête.
			// Par contre, on utilise "background-image" pour éviter que les images trop grandes cassent l'affichage en flex.
			var url = this.getURL(item);
			$('<div />').css('background-image', 'url("' + url + '")').appendTo(div);
			$('<img />').attr('src', url).on('load', onimgload);

			// Afficher la description dans le span (si visible) et en title (pour être toujours dispo)
			var description = this.describeItem(item);
			div.attr('title', description);
			$('<span />').text(description).appendTo(div);
		}
		if (animation)
			this.content.fadeIn();
		this.position.text((this.index + 1) + ' / ' + this.visibleItems.length).toggle(this.visibleItems.length > this.itemCount);
		this.prev.toggle(this.index > 0);
		this.next.toggle(this.index + this.itemCount < this.visibleItems.length);
	};

	MaterialBook.prototype.update = function(animation) {
		// Prévenir de la désélection
		if (this.onselect) {
			// En affichage multiple, on perd l'éventuelle sélection (= avec la classe "bbm-book-entry-selected") à chaque appel à "update"
			if (this.itemCount > 1 && this.content.find('.bbm-book-entry-selected').length > 0)
				this.onselect(null);
			// En affichage simple, on perd l'éventuelle sélection (= la miniature d'avant) s'il n'y a plus de miniature à afficher (et sélectionner)
			else if (this.itemCount === 1 && this.visibleItems.length === 0 && this.content.children().length > 0)
				this.onselect(null);
		}
		// Masquer la partie centrale si le book est vide mais laisser la possibilité d'annuler le filtre de recherche
		if (this.visibleItems.length === 0) {
			return this.internalHide(animation, $.noop);
		}
		// Prévenir du début de la mise à jour des visuels
		if (this.onupdate)
			this.onupdate();
		if (!animation)
			this.cursor.show();
		// Commencer par masquer les éléments précédents
		this.internalHide(animation, function() {
			// Puis afficher les nouveaux éléments
			this.internalShow(animation, function() {
				// Prévenir de la fin du chargement des images
				this.cursor.hide();
				if (this.onupdateload)
					this.onupdateload();
			}.bind(this));
			// Prévenir de la sélection, automatique, pour les book à une miniature
			if (this.onselect && this.itemCount === 1)
				this.onselect(this.visibleItems[this.index]);
		}.bind(this));
	};

	MaterialBook.prototype.filter = function() {
		var searchText = this.search.find('input').val().toLowerCase();
		var searchItem = this.searchItem;
		if (searchText) {
			this.visibleItems = this.items.filter(function(item) {
				return searchItem(item, searchText);
			});
		} else {
			this.visibleItems = this.items;
		}
	};

	MaterialBook.prototype.showFirst = function() {
		this.index = 0;
		this.update(true);
	};

	MaterialBook.prototype.showNext = function(pauseSlideshow) {
		if (pauseSlideshow)
			this.pauseSlideshow();
		this.index = (this.index + this.itemCount) % this.visibleItems.length;
		this.update(true);
	};

	MaterialBook.prototype.showPrevious = function(pauseSlideshow) {
		if (pauseSlideshow)
			this.pauseSlideshow();
		this.index = (this.index - this.itemCount + this.visibleItems.length) % this.visibleItems.length;
		this.update(true);
	};

	$.fn.materialBook = function(params) {
		// Vérification des paramètres
		if (this.length !== 1)
			throw new Error('Ce plugin ne fonctionne que sur un élément');

		// 1. Destruction avec .materialBook('destroy');
		if (params === 'destroy') {
			var book = this.data('materialBook');
			if (book)
				book.destroy();
			return this.removeData('materialBook');
		}

		// 2. Récupération avec .materialBook();
		if (typeof params === 'undefined') {
			return this.data('materialBook');
		}

		// 3. Création avec .materialBook(params);
		var options = $.extend({}, $.fn.materialBook.defaultOptions, params);
		return this.data('materialBook', new MaterialBook(this, options));
	};

	$.fn.materialBook.defaultOptions = {
		// Eléments à afficher
		items: [],
		// Position de départ dans le book
		index: 0,
		// Nombre d'éléments affichés à la fois
		itemCount: 1,
		// Organisation des éléments quand on en affiche plusieurs à la fois (row ou column pour le moment)
		direction: 'row',
		// Méthode pour générer l'URL de l'image associée à un élément (par défaut, on consière que "element" est une URL
		getURL: function(item) { return item; },

		// Un indicateur pour activer / désactiver les descriptions au démarrage (modifiable dynamiquement avec toggleDescription())
		description: false,
		// Méthode pour générer la description associée à un élément (par défaut, on n'affiche pas de description)
		describeItem: function(item) { return ''; },

		// Un indicateur pour activer / désactiver le défilement automatique
		slideshow: false,
		// Durée en ms pour le défilement automatique
		slideshowInterval: 3000,

		// Un indicateur pour activer / désactiver la zone de recherche au démarrage (modifiable dynamiquement avec toggleSearch())
		search: false,
		// Placeholder pour la zone de recherche (par défaut "...")
		searchPlaceholder: '...',
		// Méthode pour filtrer ou non l'élément en fonction d'un texte recherché (par défaut, on recherche dans "item.toString()")
		searchItem: function(item, searchTextLC) { return item.toString().toLowerCase().indexOf(searchTextLC) >= 0; },

		// Méthode appelée quand on sélectionne un éléments
		//onselect: function(item) { ... },
		// Méthode appelée quand on 'dbltap' sur un des éléments
		//ondbltap: function(visibleItems, index) { ... },
		// Méthode sans paramètre appelée quand on met à jour les visuels
		//onupdate: function() { ... },
		// Méthode sans paramètre appelée quand chaque visuel est chargé
		//onupdateload: function() { ... },
	};

	$.fn.materialTree = function(options) {

		/* Création de l'arbre DOM */
		function transformModel(item) {
			// Création d'une entrée dans l'arborescence
			var li = $('<li></li>');
			// Affichage du texte en "title" si demandé, par exemple quand le popover est trop petit pour voir le texte en entier
			if (options.showTextAsTitle)
				li.attr('title', item.text);
			// Contenu encapsulé dans un span "marqueur"
			li.append('<span class="bbm-tree-node"><span class="bbm-tree-label">' + item.text + '</span></span>');
			
			// Ajout d'un "ul" pour les enfants, si besoin
			if (item.children)
				$('<ul></ul>').append(item.children.map(transformModel)).appendTo(li);
			// Ajout de la classe CSS pour la sélection
			if (item.selectable) {
				if (!options.nodeOnly)
					li.addClass('bbm-tree-selectable').toggleClass('bbm-tree-selected', !!item.selected);
				else {
					li.addClass('bbm-tree-selectable');
					li.children('span.bbm-tree-node').toggleClass('bbm-tree-node-selected', !!item.selected);
				}
			}
			// Ajout de la classe CSS appropriée au noeud
			li.addClass(!item.children ? 'bbm-tree-leaf' : item.expanded || options.alwaysExpanded ? 'bbm-tree-expanded' : 'bbm-tree-collapsed');
			// Personnalisation si demandée
			if (options.customize)
				options.customize(li, item);
			return li[0];
		}

		return this.each(function() {
			var self = $(this);
			// Ajouter la classe CSS
			self.addClass('bbm-tree');
			// Ajouter le contenu si celui-ci n'a pas encore été généré
			if (options.items) {
				self.append(options.items.map(transformModel));
			}
			self.on('click', 'li.bbm-tree-selectable > .bbm-tree-node > .bbm-tree-label', function(event) {
				if (options.nodeOnly) {
					$(event.target).parent().toggleClass('bbm-tree-node-selected');
				} else {
					var li = $(event.target).closest('li');
					var selectedParents = li.parents('li.bbm-tree-selected');
					if(selectedParents.length > 0) {
						// On complète les noeuds parents de feuille|noeud cliqués jusqu'au parent sélectionné le plus éloigné.
						selectedParents = li.parentsUntil(selectedParents.last().parent()).filter("li");
						selectedParents.each(function(i, e) {
							var current = $(e);
							current.removeClass('bbm-tree-selected');
							var children = current.children("ul").children(".bbm-tree-selectable").not(selectedParents);
							children.addClass('bbm-tree-selected');
							children.find('.bbm-tree-selected').removeClass('bbm-tree-selected');
						});
					}
					li.toggleClass('bbm-tree-selected');
				
					// On nettoie un éventuel statut qui pourrait renseigné sur les enfants qui sera en définitive écrasé par le parent.			
					li.find('.bbm-tree-selected').removeClass('bbm-tree-selected');
				}
				// On retourne false pour éviter qu'on appelle li.bbm-tree-selectable sur les parents.
				return false;

			});
			// Déployer/diminuer des noeuds
			if(! options.alwaysExpanded) {
				self.on('click', 'li.bbm-tree-expanded > .bbm-tree-node, li.bbm-tree-collapsed > .bbm-tree-node', function(event) {
					var target = $(event.target);
					var li = target.closest('li');
					
					if(! li.hasClass('bbm-tree-selectable') 
							|| target.hasClass("bbm-tree-node")) {
						// Si le noeud est sélectionnable, on s'assure qu'on a cliqué sur le noeud.
						$(event.target).closest('li').toggleClass('bbm-tree-expanded bbm-tree-collapsed');	
					}
				});
			}
		});
	};

})(window.jQuery);
